import store, { registerStoreModuleAsync } from 'Store';
import AccountRoutes from 'Pages/Account/routes';
import BeneficiaryRoutes from 'Pages/Beneficiary/routes';
import ContactUsRoutes from 'Pages/ContactUs/routes';
import ForFarmersRoutes from 'Pages/ForFarmers/routes';
import FaqRoutes from 'Pages/Faq/routes';
import LearningCenterRoutes from 'Pages/LearningCenter/routes';
import NewsRoomRoutes from 'Pages/NewsRoom/routes';
import PortfolioRoutes from 'Pages/Portfolio/routes';
import PrimaryOfferings from 'Pages/PrimaryOfferings/routes';
import ProfileNotificationsRoutes from 'Pages/ProfileNotifications/routes';
import ProfileSettingsRoutes from 'Pages/ProfileSettings/routes';
import ResourcesRoutes from 'Pages/Resources/routes';
import SecondaryMarketRoutes from 'Pages/SecondaryMarket/routes';
import MyAdvisorsRoutes from 'Pages/MyAdvisors/routes';
import { INVESTMENT_STEPS_CONST as INVESTMENT_STEPS } from 'Config/constans';
import Login from 'Pages/Login/routes';
import SignUp from 'Pages/SignUp/routes';
import ResetPassword from 'Pages/ResetPassword/routes';

const PageAccreditation = () => import(/* webpackChunkName: 'PageAccreditation' */ 'Components/PageAccreditation/PageAccreditation');
const PageFarm = () => import(/* webpackChunkName: 'PageFarm' */ 'Components/PageFarm/PageFarm');
const PageInvestment = () => import(/* webpackChunkName: 'PageInvestment' */ 'Components/PageInvestment/PageInvestment');
const PageInvestmentComplete = () => import(/* webpackChunkName: 'PageInvestmentComplete' */ 'Components/PageInvestmentComplete/PageInvestmentComplete');
const PagePledge = () => import(/* webpackChunkName: 'PagePledge' */ 'Components/PagePledge/PagePledge');
const PageSignUpSocial = () => import(/* webpackChunkName: 'PageRegister' */ 'Components/PageSignUpSocial/PageSignUpSocial');
const PageError = () => import(/* webpackChunkName: 'PageError' */ 'Components/PageError/PageError');
const PageCompany = () => import(/* webpackChunkName: 'PageCompany' */ 'Components/PageCompany/PageCompany');
const PageFarmValue = () => import(/* webpackChunkName: 'PageFarmValue' */ 'Components/PageFarmValue/PageFarmValue');
const PageFarmValueStates = () => import(/* webpackChunkName: 'PageFarmValueStates' */ 'Components/PageFarmValueStates/PageFarmValueStates');

const routes = [
  {
    path: '/masters',
    beforeEnter() {
      window.location.href = 'https://info.acretrader.com/bloomberg?hs_preview=cPTMtpKN-119571275407';
    },
  },
  {
    path: '/home',
    beforeEnter() {
      window.location.href = '/';
    },
  },
  // {
  //   path: '/careers',
  //   beforeEnter() {
  //     window.location.href = 'https://ats.rippling.com/acretrader-jobs/jobs';
  //   },
  // },
  ...SignUp,
  {
    path: '/sign-up-social',
    name: 'sign-up-social',
    component: PageSignUpSocial,
    meta: {
      skipRedirectToRoute: true,
      requiresAuth: true,
      requiresProfileData: true,
    },
    children: [
      {
        path: 'accreditation',
        name: 'sign-up-social-accreditation',
      },
    ],
  },
  ...Login,
  {
    path: '/accreditation',
    name: 'accreditation',
    component: PageAccreditation,
    meta: {
      requiresAuth: true,
      skipRedirectToRoute: true,
      store: ['profile/getProfileData', 'page/getPageData'],
    },
  },
  ...ResetPassword,
  // NEW ROUTES
  ...AccountRoutes,
  ...ProfileNotificationsRoutes,
  ...ProfileSettingsRoutes,
  ...SecondaryMarketRoutes,
  ...PortfolioRoutes,
  ...BeneficiaryRoutes,
  ...MyAdvisorsRoutes,
  // !!
  {
    path: '/explore',
    name: 'explore',
    redirect: { name: 'primary-offerings' },
  },
  ...PrimaryOfferings,
  ...ResourcesRoutes,
  {
    path: '/resources/investors',
    redirect: { name: 'investors' },
  },
  ...ForFarmersRoutes,
  {
    path: '/resources/farmland-values',
    name: 'farmland-values',
    component: PageFarmValue,
    meta: {
      skipRouteLoading: true,
      storeModules: [{
        name: 'valueTools',
        module: () => import(/* webpackChunkName: 'valueToolsStoreModule' */ 'Store/valueTools'),
      }],
    },
    redirect: to => `${to.path}/farmland-returns`,
    children: [
      {
        path: 'farmland-returns',
        name: 'farmland-returns',
        component: PageFarmValue,
        meta: {
          skipScrollTab: true,
          store: ['page/getPageData'],
        },
      },
      {
        path: 'farmland-prices',
        name: 'farmland-prices',
        component: PageFarmValue,
        meta: {
          skipScrollTab: true,
          store: ['page/getPageData'],
        },
      },
      {
        path: 'rental-rates',
        name: 'rental-rates',
        component: PageFarmValue,
        meta: {
          skipScrollTab: true,
          store: ['page/getPageData'],
        },
      },
      {
        path: 'rankings',
        name: 'rankings',
        component: PageFarmValue,
        meta: {
          skipScrollTab: true,
          store: ['page/getPageData'],
        },
      },
    ],
  },
  {
    path: '/resources/:slug-farmland-:tab',
    name: 'values-state-single',
    component: PageFarmValueStates,
    meta: {
      skipScrollTab: true,
      storeModules: [{
        name: 'valueTools',
        module: () => import(/* webpackChunkName: 'valueToolsStoreModule' */ 'Store/valueTools'),
      }],
      store: ['valueTools/getStateMapData'],
    },
  },
  ...LearningCenterRoutes,
  {
    path: '/company',
    name: 'company',
    component: PageCompany,
    meta: {
      store: ['page/getPageData'],
    },
  },
  ...ContactUsRoutes,
  ...NewsRoomRoutes,
  ...FaqRoutes,
  {
    path: '/404',
    name: '404',
    component: PageError,
  },
  {
    path: '/error',
    name: 'error',
    component: PageError,
    children: [
      {
        path: ':code',
        name: 'error-code',
      },
    ],
  },
  {
    path: '/:slug/investment-process/:investmentId/complete',
    name: 'investment-process-complete',
    component: PageInvestmentComplete,
    meta: {
      requiresAuth: true,
      requiresAccreditation: true,
      onLogoutRedirect: { name: 'farm' },
      requiresEmailVerification: true,
      onEmailVerificationRedirect: route => ({ ...route, name: 'farm' }),
      store: ['farm/getFarmData', 'account/loadAccountListOnce'],
    },
  },
  {
    path: '/:slug/pledge/complete',
    name: 'pledge-complete',
    component: PageInvestmentComplete,
    meta: {
      store: ['farm/getFarmData'],
      requiresAuth: true,
      requiresAccreditation: true,
      onLogoutRedirect: { name: 'farm' },
      requiresEmailVerification: true,
      onEmailVerificationRedirect: route => ({ ...route, name: 'farm' }),
    },
  },
  {
    path: '/:slug/pledge',
    name: 'pledge',
    component: PagePledge,
    meta: {
      store: ['farm/getFarmData'],
      requiresAuth: true,
      requiresAccreditation: true,
      requiresConfirmLogout: true,
      onLogoutRedirect: { name: 'farm' },
    },
  },
  {
    path: '/:slug/investment-process',
    name: 'investment-process',
    component: PageInvestment,
    async beforeEnter(to, from, next) {
      // get private token from url
      let privateToken = to.query.token;
      const privateTokenKey = `private-token-${to.params.slug}`;
      // if there is private token in url
      if (privateToken) {
        // set it to store
        localStorage.setItem(privateTokenKey, privateToken);
      } else {
        // get private token from store
        privateToken = localStorage.getItem(privateTokenKey);
      }
      // If privateToken exist
      if (privateToken) {
        // get farm data with private token
        await store.dispatch('farm/getFarmData', { slug: to.params.slug, privateToken });
        // and set private token to investment store to use it for every request during investment process
        store.dispatch('investment/setInvestmentPrivateToken', privateToken);
      } else {
        // otherwise, get farm data without private token
        await store.dispatch('farm/getFarmData', { slug: to.params.slug });
      }

      // if can't invest in farm, return to farm page
      if (!store.getters['farm/isCanInvest']) {
        // if current page is farm, just cancel route change
        if (from.name === 'farm') next(new Error('cancel'));
        else next({ name: 'farm', params: to.params });
        return;
      }
      next();
    },
    meta: {
      async resolve(to, from, next) {
        // This hook is guarantee that login requirements is passed!
        // Check if unfinished investment exist and redirect to it if yes
        if (to.name === 'investment-process') {
          // get farm data
          const farmData = store.getters['farm/farmData'];
          // get unfinished investment id for this farm
          const unfinishedInvestment = await store.dispatch('farm/getFarmUnfinishedInvestment', farmData.id);
          // if exists
          if (unfinishedInvestment?.id) {
            // redirect to last investment process step
            next({
              name: 'investment-process-step',
              params: {
                ...to.params,
                investmentId: unfinishedInvestment.id,
                step: INVESTMENT_STEPS.CONFIRMATION,
              },
            });
            return;
          }
        }
        // register advisors module
        await registerStoreModuleAsync('myAdvisors');
        // load advisors list
        await store.dispatch('myAdvisors/loadAdvisorsList');
        // register account module
        await registerStoreModuleAsync('account');
        // load accounts list
        await store.dispatch('account/loadAccountListOnce');
        // If there is no accounts which can invest
        if (!store.getters['account/isSomeAccountCanInvest']) {
          // redirect to farm page
          next({ name: 'farm', params: to.params, query: to.query });
        } else {
          next();
        }
      },
      requiresAuth: true,
      requiresAccreditation: true,
      requiresConfirmLogout: true,
      requiresEmailVerification: true,
      onEmailVerificationRedirect: route => ({ ...route, name: 'farm' }),
      onLogoutRedirect: { name: 'farm' },
      store: ['custodian/loadCustodianList'],
    },
    children: [
      {
        path: ':investmentId/:step',
        name: 'investment-process-step',
        meta: {
          requiresConfirmLogout: true,
          store: ['investment/getInvestmentList'],
        },
      },
    ],
  },
  {
    path: '/:slug',
    name: 'farm',
    component: PageFarm,
    async beforeEnter(to, from, next) {
      await registerStoreModuleAsync('account');
      next();
    },
    meta: {
      store: ['farm/getFarmData'],
      updateStoreData: true,
      storeModules: [{
        name: 'account',
        module: () => import(/* webpackChunkName: 'accountStoreModule' */ 'Store/account'),
      }],
      resolve() {
        if (store.getters['login/isLoggedIn']) store.dispatch('account/loadAccountListOnce');
      },
    },
    children: [
      {
        path: 'maps',
        name: 'farm.maps',
        meta: {
          skipScrollTab: true,
        },
      },
      {
        path: 'financials',
        name: 'farm.financials',
        meta: {
          skipScrollTab: true,
          requiresAuth: true,
          onLogoutRedirect: { name: 'farm' },
        },
      },
      {
        path: 'documents',
        name: 'farm.documents',
        meta: {
          skipScrollTab: true,
          requiresAuth: true,
          onLogoutRedirect: { name: 'farm' },
        },
      },
      {
        path: 'rating',
        name: 'farm.rating',
        meta: {
          skipScrollTab: true,
        },
      },
      {
        path: 'notes',
        name: 'farm.notes',
        meta: {
          skipScrollTab: true,
          requiresAuth: true,
          onLogoutRedirect: { name: 'farm' },
        },
      },
    ],
  },
  {
    path: '*',
    redirect: { name: '404' },
  },
];
if (process.env.ENV === 'development') {
  const TempHomePage = () => import(/* webpackChunkName: 'TempHomePage' */ 'Components/TempHomePage/TempHomePage');

  routes.push({
    path: '/',
    name: 'home-gap',
    component: TempHomePage,
    meta: {
      store: ['farm/getList'],
    },
  });
}

export default routes;
